module.exports = __webpack_public_path__ + "assets/img/eleFour.812715eb.png";